import Message from './components/Message/Message';
import bgDefault from './assets/images/bg.png';
import bgS1 from './assets/images/bg1.png';
import bgS2 from './assets/images/bgs2.png';
import { useBroadcast } from './hooks/useBroadcast';
import Advt from './components/Advt/Advt';
import { Winners } from './components/Winners/Winners';

function App() {
  const { isVisible, currentMessage, currentState, showedMessages } =
    useBroadcast();

  return (
    <div
      style={{
        background: `url(${bgDefault}) center/cover no-repeat`,
        width: '100vw',
        height: '100vh',
      }}>
      {isVisible && currentState === 'S1' && (
        <div
          className="app-wrapper"
          style={{
            background: `url(${bgS1}) center/cover no-repeat`,
          }}>
          <div className="message-wrapper">
            {currentMessage && (
              <Message
                message={currentMessage?.message || {}}
                currentState={currentState}
              />
            )}
          </div>

          <div className="advtWrapper">
            <Advt />
          </div>

          <div id="img-loader"></div>
        </div>
      )}
      {isVisible && currentState === 'S2' && (
        <div
          className="app-wrapper"
          style={{
            background: `url(${bgS2}) center/cover no-repeat`,
          }}>
          <div className="winnersWrapper">
            <Winners messages={showedMessages || []} />
          </div>

          <div id="img-loader"></div>
        </div>
      )}
    </div>
  );
}

export default App;
